<template>
  <div>
    <Button type="success" class="mt20" @click="showAddModal = true" v-check-auth="'/warehouse-transfer-station/create'">录入</Button>
    <Button type="success" class="mt20" style="margin-left:20px;" @click="showAddImportModal = true" v-check-auth="'/warehouse-transfer-station/add-import'">批量导入</Button>
    <Button style="margin-left:20px;" type="success" class="mt20" @click="importData" v-check-auth="'/admin/v1/warehouse-transfer-station/import'">批量自动拆分</Button>
    <Form ref="queryForm" :model="query" :label-width="100" inline>
      <FormItem label="仓库渠道：" prop="name">
        <Select v-model="query.warehouse_channel_id" placeholder="请选择仓库渠道" clearable>
          <Option v-for="(item, i) in channelList" :key="i" :label="item.name" :value="item.id"></Option>
        </Select>
      </FormItem>
      <FormItem label="用户名:" class="inline" :label-width="100">
        <Select
          placeholder="请选择操作人员"
          v-model="query.user_id"
          filterable
          remote
          clearable
          :remote-method="($event) => loadUserList($event)">
          <Option v-for="item in userList" :value="item.id" :key="item.id">{{ item.username }}</Option>
        </Select>
      </FormItem>
      <FormItem label="物料" class="inline">
        <Select
          style="width: 160px;"
          v-model="query.material_id"
          filterable
          remote
          clearable
          :remote-method="($event) => loadMaterials($event)">
          <Option v-for="item in materialsList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label="状态">
        <Select v-model="query.status" placeholder="请选择状态" clearable>
          <Option v-for="(item, i) in statusList" :key="i" :value="(i + 1) * 10" :label="item"></Option>
        </Select>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="loadData">查询</Button>
      </FormItem>
    </Form>

    <Table border :columns="columns" :data="tableData">
      <template slot-scope="{ row }" slot="action">
        <Button size="small" type="primary" v-if="row.status === 10" @click="handleCheck(row)"
        v-check-auth="'/warehouse-transfer-station/view/check'" style="margin-top:5px;margin-bottom:5px;margin-left:5px;">检测</Button>
        <Button style="margin-top:5px;margin-bottom:5px;margin-left:5px;" size="small" type="primary" @click="showCreateLog(row)" v-if="row.status === 20" v-check-auth="'/warehouse-transfer-station/view/create-warehouse-log'">拆分入库</Button>
        <Button style="margin-top:5px;margin-bottom:5px;margin-left:5px;" size="small" type="primary" v-check-auth="'/warehouse-transfer-station/view/create-warehouse-log'" @click="showGoodsLog(row)" v-if="row.status === 20 || row.status === 30">良品出库</Button>
        <Button style="margin-top:5px;margin-bottom:5px;margin-left:5px;" size="small" type="primary"  @click="handleSendOut(row)" v-check-auth="'/warehouse-transfer-station/view/send-out'" v-if="row.status === 20 || row.status === 30">发货</Button>
        <Button style="margin-top:5px;margin-bottom:5px;margin-left:5px;" size="small" type="primary" @click="handleComplete(row)" v-if="row.status === 20 || row.status === 30 || row.status === 40" v-check-auth="'/warehouse/view/complete'">锁帐</Button>
        <Button style="margin-top:5px;margin-bottom:5px;margin-left:5px;" size="small" type="primary" @click="handleRecordModel(row)" v-check-auth="'/warehouse-transfer-station-action-log'">操作记录</Button>
        <Button style="margin-top:5px;margin-bottom:5px;margin-left:5px;" size="small" type="primary" @click="handleOutInWarehouseModel(row)" v-check-auth="'/warehouse-log'">出入库单</Button>
      </template>
    </Table>

    <Page :total="totalCount" @on-change="handlePageChange" @on-page-size-change="handlePageSizeChange" size="small" show-total show-elevator show-sizer :page-size-opts="[20,50,100]" :page-size="query['per-page']"/>

    <Modal v-model="showAddModal" footer-hide title="录入中转单据">
      <Form :data="formData" :label-width="100">
        <FormItem label="仓库渠道：" prop="name" inline>
          <Select v-model="formData.warehouse_channel_id" placeholder="请选择仓库渠道" clearable :style="{width: '300px'}">
            <Option v-for="(item, i) in channelList" :key="i" :label="item.name" :value="item.id"></Option>
          </Select>
        </FormItem>
        <FormItem label="物料：" class="inline">
          <Select
            style="width: 160px;"
            v-model="formData.material_id"
            filterable
            remote
            clearable
            :remote-method="($event) => loadMaterials($event)">
            <Option v-for="item in materialsList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="数量：">
          <Input v-model="formData.quantity" placeholder="请输入数量"/>
        </FormItem>
        <FormItem label="说明：">
          <Input type="textarea" v-model="formData.remark"/>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="submitForm">确定</Button>
        </FormItem>
      </Form>
    </Modal>
    <!-- 拆分入库弹窗 -->
    <Modal v-model="showCreateLogModal" title="拆分入库" @on-ok="submitLogForm" loading>
      <Form :data="logFormData" :label-width="100">
        <FormItem label="物料：">
          <Input v-model="selectRow.material_name" readonly/>
        </FormItem>
        <FormItem label="数量：">
          <Input v-model="selectRow.quantity"/>
        </FormItem>
        <FormItem label="分类：">
          <RadioGroup v-model="logFormData.no_type">
            <Radio v-for="(item, i) in warehouseLogTypes" :key="i" :label="item.id"><span>{{ item.name }}</span></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="入库：">
          <Select v-model="logFormData.warehouse_id" @on-change="handleWarehouseChange">
            <Option v-for="item in warehouses" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="库位：">
          <Select v-model="logFormData.warehouse_position_id">
            <Option v-for="item in warehousePositions" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="备注：">
          <Input v-model="logFormData.remark" placeholder="请输入备注信息"/>
        </FormItem>
        <FormItem label="入库子料：">
          <Form inline v-for="(item, i) in materialsItemList" :key="i">
            <FormItem label="物料：">
              <Input v-model="item.material_name"  readonly/>
            </FormItem>
            <FormItem label="数量：">
              <Input :value="item.quantity * selectRow.quantity" readonly/>
            </FormItem>
          </Form>
        </FormItem>
      </Form>
    </Modal>

    <!-- 良品出库弹窗 -->
    <Modal v-model="showGoodsModal" title="良品出库" ref="goodsRef" @on-ok="submitGoodsForm" loading>
      <Form :data="goodsFormData" :label-width="100">
        <FormItem label="物料：">
          <Input v-model="selectRow.material_name" readonly/>
        </FormItem>
        <FormItem label="数量：">
          <Input v-model="selectRow.quantity"/>
        </FormItem>
        <FormItem label="分类：">
          <RadioGroup v-model="goodsFormData.no_type">
            <Radio v-for="(item, i) in warehouseLogTypes" :key="i" :label="item.id"><span>{{ item.name }}</span></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="出库：">
          <Select v-model="goodsFormData.warehouse_id" @on-change="handleWarehouseChange">
            <Option v-for="item in warehouses" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="库位：">
          <Select v-model="goodsFormData.warehouse_position_id">
            <Option v-for="item in warehousePositions" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="备注：">
          <Input v-model="goodsFormData.remark" placeholder="请输入备注信息"/>
        </FormItem>
      </Form>
    </Modal>
    <!-- 操作记录弹窗 -->
    <Modal v-model="showRecordModal" title="操作记录">
      <Table border :columns="recordColumns" :data="recordData"></Table>
    </Modal>
    <!-- 出入库单弹窗 -->
    <Modal v-model="showOutInModal" title="出入库单" width="880px">
      <Table border :columns="outInColumns" :data="outInData"></Table>
    </Modal>
    <!-- 导入弹窗 -->
    <Modal
      v-model="importModal" width:="640"  title="导入数据">
        <import-upload url="/warehouse-transfer-stations/import" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @success="importSuccess"></import-upload>
    </Modal>

    <Modal
      v-model="showAddImportModal" width:="640"  title="导入数据">
        <import-upload url="/warehouse-transfer-stations/add-import" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @success="importSuccess"></import-upload>
    </Modal>
  </div>
</template>

<script>
import { WarehouseTransferStation, WarehouseChannel, Warehouse, WarehouseLog, WarehousePosition, User, Material, MaterialSplitItem, WarehouseTransferStationActionLog } from '@/services/resources'
import WarehouseLogType from '@/mixins/warehouse-log-type'
import ImportUpload from '@/components/ImportUpload'
export default {
  name: 'WarehouseTransferStation',
  mixins: [ WarehouseLogType ],
  components: {
    ImportUpload
  },
  data () {
    return {
      importModal: false,
      showAddModal: false,
      showAddImportModal: false,
      showGoodsModal: false,
      showRecordModal: false, // 操作记录弹窗显示
      showOutInModal: false, // 出入库单弹窗显示
      showCreateLogModal: false, // 是否显示拆分入库弹窗
      formData: {}, // 添加新增表单数据
      logFormData: {}, // 拆分单入库弹窗数据
      goodsFormData: {}, // 良品出库弹窗数据
      selectRow: {}, // 选中数据row
      selectRowAllCount: 0, // 选中数据总物料数量
      warehouses: [], // 库名称
      warehousePositions: [], // 库位列表
      query: {
        'per-page': 20,
        page: 1,
        warehouse_channel_id: 1
      },
      channelList: [], // 仓库渠道列表数据
      userList: [], // 用户列表
      materialsList: [], // 物料列表
      materialsItemList: [], // 拆分物料信息列表
      statusList: ['检测中', '分拣拆分中', '良品出库中', '已发货', '已所帐'],
      tableData: [], // 表格数据
      recordData: [], // 操作记录数据
      outInData: [], // 出入库单数据
      totalCount: 0,
      remark: '' // 备注信息
    }
  },
  computed: {
    columns () {
      return [
        {
          title: '编号',
          key: 'id'
        },
        {
          title: '单据号',
          key: 'no'
        },
        {
          title: '物料',
          key: 'material_name'
        },
        {
          title: '数量',
          key: 'quantity'
        },
        {
          title: '说明',
          key: 'material_name'
        },
        {
          title: '状态',
          key: 'status_name'
        },
        {
          title: '操作人',
          key: 'user_name'
        },
        {
          title: '录入时间',
          key: 'created_at'
        },
        {
          title: '操作',
          slot: 'action',
          align: 'left',
          width: 200
        }
      ]
    },
    recordColumns () {
      return [
        { title: '操作', key: 'action_name' },
        { title: '操作人', key: 'user_name' },
        { title: '操作时间', key: 'created_at' },
        { title: '情况说明', key: 'remark' }
      ]
    },
    outInColumns () {
      return [
        {
          title: '编号',
          key: 'id'
        },
        {
          title: '流水号',
          key: 'no'
        },
        {
          title: '仓库名称',
          key: 'warehouse_name'
        },
        {
          title: '物料',
          render: (h, params) => {
            const row = params.row
            return row.items.map(item => {
              return <p>{item.material_name + ' x' + item.quantity}</p>
            })
          }
        },
        {
          title: '单据日期',
          key: 'no_date'
        },
        {
          title: '类型',
          key: 'type_name'
        },
        {
          title: '状态',
          width: 100,
          render: (h, params) => {
            const row = params.row
            const status = row.status === 100 ? 'success' : row.status === 2 ? 'success' : 'error'
            return h('Badge', {
              props: {
                status: status,
                text: row['status_name']
              }
            })
          }
        },
        {
          title: '操作人',
          width: 80,
          key: 'user_name'
        },
        {
          title: '说明',
          key: 'remark'
        },
        {
          title: '创建时间',
          key: 'created_at'
        },
        {
          title: '更新时间',
          key: 'updated_at'
        }
      ]
    }
  },
  created () {
    this.loadData()
    this.loadWarehouses()
    this.loadChannelList()
  },
  methods: {
    importData () { // 导入
      this.importModal = true
    },
    importSuccess () {
      this.$Message.success('导入成功！')
      this.importModal = false
      this.loadData()
    },
    handleOutInWarehouseModel (row) { // 出入库单
      WarehouseLog.query({ warehouse_transfer_station_id: row.id }).then(({ data }) => {
        this.outInData = data
        this.showOutInModal = true
      })
    },
    handleRecordModel (row) { // 操作记录
      WarehouseTransferStationActionLog.query({ warehouse_transfer_station_id: row.id }).then(({ data }) => {
        this.recordData = data
        this.showRecordModal = true
      })
    },
    handleSendOut (row) { // 发货
      this.$Modal.confirm({
        title: '温馨提示',
        render: (h) => {
          return h('Input', {
            props: {
              value: this.value,
              autofocus: true,
              placeholder: '请输入备注信息'
            },
            on: {
              input: val => {
                this.remark = val
              }
            }
          })
        },
        onOk: () => {
          WarehouseTransferStation.sendOut({ id: row.id, remark: this.remark }).then(({ data }) => {
            this.$Message.success('操作成功！')
            this.$Modal.remove()
            this.loadData()
          })
        }
      })
    },
    handleComplete (row) {
      this.$Modal.confirm({
        title: '温馨提示',
        render: (h) => {
          return h('Input', {
            props: {
              value: this.value,
              autofocus: true,
              placeholder: '请输入备注信息'
            },
            on: {
              input: val => {
                this.remark = val
              }
            }
          })
        },
        onOk: () => {
          WarehouseTransferStation.complete({ id: row.id, remark: this.remark }).then(({ data }) => {
            this.$Message.success('操作成功！')
            this.$Modal.remove()
            this.loadData()
          })
        }
      })
    },
    submitGoodsForm () { // 提交良品出库表单
      console.log(this.selectRow)
      this.goodsFormData = {
        ...this.goodsFormData,
        id: this.selectRow.id,
        out_in: 1,
        items: [{ material_id: this.selectRow.material_id, quantity: this.selectRow.quantity }]
      }
      WarehouseTransferStation.createWarehouseLog(this.goodsFormData).then(({ data }) => {
        this.$Message.success('操作成功！')
        this.showGoodsModal = false
        this.loadData()
      }).catch(() => {
        this.$refs['goodsRef'].loading = false
      })
    },
    submitLogForm () { // 提交拆分入库表单
      const items = this.materialsItemList.map((item, i) => {
        return {
          material_id: item.material_id,
          quantity: item.quantity * this.selectRow.quantity
        }
      })
      this.logFormData = {
        ...this.logFormData,
        id: this.selectRow.id,
        out_in: 2,
        all_count: this.selectRowAllCount,
        split_count: this.selectRow.quantity,
        items
      }
      WarehouseTransferStation.createWarehouseLog(this.logFormData).then(({ data }) => {
        this.$Message.success('操作成功！')
        this.showCreateLogModal = false
        this.loadData()
      }).catch(() => {
        this.showCreateLogModal = false
      })
    },
    handleWarehouseChange (val) { // 仓库改变获取库位
      WarehousePosition.query({ warehouse_id: val }).then(({ data }) => {
        this.warehousePositions = data
      })
    },
    loadMaterialItems (row) { // 加载拆分物料列表
      MaterialSplitItem.query({ split_material_id: row.material_id }).then(({ data }) => {
        this.materialsItemList = data.length ? data : [{ material_name: this.selectRow.material_name, material_id: this.selectRow.material_id, quantity: 1 }]
      })
    },
    loadWarehouses () {
      Warehouse.query().then(res => {
        this.warehouses = res.data
      })
    },
    showGoodsLog (row) {
      this.showGoodsModal = true
      this.selectRow = row
    },
    showCreateLog (row) {
      this.showCreateLogModal = true
      this.selectRow = row
      this.selectRowAllCount = row.quantity
      this.loadMaterialItems(row)
    },
    handleCheck (row) {
      this.remark = ''
      this.$Modal.confirm({
        title: '确定检测？',
        loading: true,
        render: (h) => {
          return h('Input', {
            props: {
              value: this.value,
              autofocus: true,
              placeholder: '请输入备注信息'
            },
            on: {
              input: val => {
                this.remark = val
              }
            }
          })
        },
        onOk: (val) => {
          WarehouseTransferStation.check({ id: row.id, remark: this.remark }).then(({ data }) => {
            this.$Message.success('操作成功！')
            this.$Modal.remove()
            this.loadData()
          })
        }
      })
    },
    submitForm () {
      if (!this.formData.warehouse_channel_id) {
        this.$Message.warning('请选择渠道！')
        return false
      }
      if (!this.formData.material_id) {
        this.$Message.warning('请选择物料')
        return false
      }
      if (!this.formData.quantity) {
        this.$Message.warning('请输入数量！')
        return false
      }
      WarehouseTransferStation.create({ ...this.formData })
        .then(res => {
          this.$Message.success('创建成功！')
          this.showAddModal = false
          this.loadData()
        })
    },
    loadData () {
      WarehouseTransferStation.query({ ...this.query })
        .then(res => {
          this.tableData = res.data
          this.totalCount = parseInt(res.headers['x-pagination-total-count'])
        })
    },
    loadChannelList () {
      WarehouseChannel.query({ 'per-page': 100, 'page': 1 }).then(resp => {
        this.channelList = resp.data
      })
    },
    handlePageChange (page) {
      this.query.page = page
      this.loadData()
    },
    handlePageSizeChange (perPage) {
      this.query['per-page'] = perPage
      this.loadData()
    },
    async loadUserList (event) {
      let resp = await User.query({ username: event })
      this.userList = resp.data
    },
    async loadMaterials (query) {
      let resp = await Material.query({ keyword: query, 'per-page': 3000, 'page':1 })
      this.materialsList = resp.data
    }
  }
}
</script>

<style lang="scss">
  .mt20 {
    margin-top: 20px;
  }
</style>
